import {Component, OnDestroy, OnInit,Input} from '@angular/core';
import { GlobalsService } from '@services/micro/globals.service';
import { LanguagesModalComponent } from '@modals/languages-modal/languages-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute} from '@angular/router';
import {AmKeyboardService} from "@components/am-keyboard/am-keyboard.service";
import { TranslateService } from '@ngx-translate/core';
import { LanguagesInt } from '@app/interfaces';
import {Subscription} from "rxjs";
import {unsubscribe} from "@app/utils";
/**
  Componente que muestra un botón para cambiar el idioma de la aplicación.
  Este componente permite abrir un modal con una lista de idiomas disponibles
  y cambiar el idioma seleccionado. También gestiona la suscripción a cambios
  en el idioma actual y la lógica de desuscripción para evitar fugas de memoria.
**/
@Component({
    selector: 'app-button-languages',
    templateUrl: './button-languages.component.html',
    styleUrls: ['./button-languages.component.scss'],
    standalone: false
})
export class ButtonLanguagesComponent implements OnInit, OnDestroy {
  @Input() showTextLenguages: boolean = true;
/**
    Página actual en la que se encuentra el usuario.
    @type {number}
  **/
    pageCurrent: number = 0;

    /**
      Idioma actual seleccionado en la aplicación.
      @type {string}
    **/
    currentLang: string = '';
  
    /**
      Indica si el idioma seleccionado no está permitido (es_MX, en_US, es-MX, en-US).
      @type {boolean}
    **/
    otherNotAllowed: boolean;
  
    /**
      Suscripción para manejar cambios en el idioma actual.
      @type {Subscription}
    **/
    sub: Subscription;
  
    /**
      Texto que se muestra en el botón.
      @type {string}
    **/
    text = '';

  constructor(
    private modalService: NgbModal,
    private _keyboard: AmKeyboardService,
    public globals: GlobalsService,
    private _globalService: GlobalsService,
    private translate: TranslateService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    console.log('showTextLenguages ' , this.showTextLenguages)
    this.pageCurrent = this.route.snapshot.url.length;
    this.sub = this.globals.language$.subscribe( {
      next: (id )=> {
        this.currentLang = id ;

        this.globals.languageSelected = this.globals.languages.find(la => la.id === id || la.id === id.replace("_","-"));
        this.otherNotAllowed = ['es_MX', 'en_US', 'es-MX', 'en-US'].includes(id);
      }
    })
  }

  ngOnDestroy() {
    unsubscribe([this.sub])
  }
  /**
    Abre un modal con la lista de idiomas disponibles para seleccionar.
    @return void
  **/
  open(): void {
    this._keyboard.destroy()
    const modalRef = this.modalService.open( LanguagesModalComponent,
      {
        centered: true,
        size: 'xl',
        backdrop : 'static',
        keyboard : false
      });
    modalRef.componentInstance.msg_validauser = '';
  }
/**
    Maneja la selección de un idioma en el modal.
    Actualiza el idioma seleccionado en la aplicación y en los servicios globales.
    @param {LanguagesInt} select - Idioma seleccionado.
    @return void
  **/
  onSelected(select: LanguagesInt): void {
    this._globalService.languageSelected = select;
    this.translate.use(select.id);
    this._globalService.language$.next(select.id.replace("-", "_"))
  }

}
